import * as React from "react";
import { Grid, Statistic, Header } from "semantic-ui-react";

interface Props {
    didNotAttendAppointmentsLast12Months: number;
    didNotAttendAppointmentsMonthToDate: number;
}

export const DnasStatistics: React.FC<Props> = (props: Props) => {
    return (
        <>
            <Header textAlign="center" as="h1">Number of DNA's</Header>
            <Grid>
                <Grid.Row columns={2}>
                    <Grid.Column>
                        <Statistic>
                            <Statistic.Value>{props.didNotAttendAppointmentsMonthToDate}</Statistic.Value>
                            <Statistic.Label>Month to Date</Statistic.Label>
                        </Statistic>
                    </Grid.Column>
                    <Grid.Column>
                        <Statistic>
                            <Statistic.Value>{props.didNotAttendAppointmentsLast12Months}</Statistic.Value>
                            <Statistic.Label>Last 12 Months</Statistic.Label>
                        </Statistic>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    );
};
